var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-icon',{attrs:{"small":""},on:{"click":_vm.copy}},[_vm._v("mdi-content-copy")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }